import React, { useState } from "react";
import "./Navbar.css";
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Import React Icons
import * as FaIcons from "react-icons/fa";

// ✅ Explicitly type icons for TypeScript safety
const FaBars = FaIcons.FaBars as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaUser = FaIcons.FaUser as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaHome = FaIcons.FaHome as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaSignOutAlt = FaIcons.FaSignOutAlt as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const FaSignInAlt = FaIcons.FaSignInAlt as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface NavbarProps {
  isSidebarOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Navbar: React.FC<NavbarProps> = ({ isSidebarOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const { currentUser, logout } = useAuth();

  const toggleProfileDropdown = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsProfileDropdownOpen((prev) => !prev);
  };

  const handleSignOut = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/");
    }
  };

  return (
    <div className={`navbar ${isSidebarOpen ? "navbar-expanded" : "navbar-collapsed"}`}>
      {/* Sidebar toggle */}
      <button className="toggle-btn" onClick={() => setIsOpen((prev) => !prev)}>
        <FaBars className="icon_nav_bar" />
      </button>

      <div className="navbar-content">
        <img src={logo} alt="E-Commerce Logo" className="logo" />

        <div className="profile-dropdown">
          {currentUser ? (
            <>
              <div className="profile-icon_nav_bar" onClick={toggleProfileDropdown}>
                <span>{currentUser.username || currentUser.email}</span> <FaUser className="icon_nav_bar" />
              </div>

              {isProfileDropdownOpen && (
                <div className="dropdown-menu">
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      if (currentUser.role === "admin") {
                        navigate(`/admin/profile/${currentUser.id}`);
                      } else if (currentUser.role === "vendor") {
                        navigate(`/vendor/vendorprofile/${currentUser.id}`);
                      } else {
                        navigate(`/user/profile/${currentUser.id}`);
                      }
                      setIsProfileDropdownOpen(false);
                    }}
                  >
                    <FaUser className="icon_nav_bar" />
                    {currentUser.role === "admin"
                      ? " Admin Profile"
                      : currentUser.role === "vendor"
                      ? " Vendor Profile"
                      : " My Profile"}
                  </div>

                  <div className="dropdown-item" onClick={() => navigate("/")}>
                    <FaHome className="icon_nav_bar" /> Home
                  </div>

                  <div className="dropdown-item" onClick={handleSignOut}>
                    <FaSignOutAlt className="icon_nav_bar" /> Sign Out
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="profile-icon_nav_bar" onClick={() => navigate("/login")}>
              <span>Login</span> <FaSignInAlt className="icon_nav_bar" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
